/*******************************************************************************
* @ngdoc  provider
* @name   tagAdmin.provider:Services
* @description
* Services specific to Tag Admin.
*******************************************************************************/
/* @ngInject */ export function TagAdminServiceProvider() {
  /**
   * @ngdoc property
   * @name  ServicesProvider#httpServiceBase
   * @description
   * Server side controller URL.
   */
  this.httpServiceBase = '/books/tagAdmin/';

  /**
   * @ngdoc property
   * @name  ServicesProvider#httpServices
   * @description
   * Server side service methods.
   */
  this.httpServices = (http) => ({
    drop: (id) => http.get(`drop/${id}`),
    getTagList: () => http.post(`getTagList`)
  });

  this.$get = ['HTTPService', function (HTTPService) {
    return HTTPService.make(this.httpServiceBase, this.httpServices);
  }];
}